import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import swal from "sweetalert";

const WhatsAppCustomMessage = () => {
  const [message, setMessage] = useState("");
  const eventid = localStorage.getItem("eventid");

  // Fetch saved message on mount
  useEffect(() => {
    fetchSavedMessage();
  }, []);

  const fetchSavedMessage = async () => {
    try {
      const res = await axios.get(`/api/conference-get-whatsapp-custom-message/${eventid}`);
      if (res.data.status === 200 && res.data.data) {
        setMessage(res.data.data.message);
      }
    } catch (error) {
      console.error("Error fetching saved message:", error);
    }
  };

  const handleSaveCustomMessage = async () => {
    if (!message.trim()) {
      alert("Please enter a message.");
      return;
    }

    const data = { eventid: eventid, message: message };
    try {
      await axios.get("/sanctum/csrf-cookie");
      const res = await axios.post("api/conference-whatsapp-custom-message", data);

      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
      } else {
        swal("Warning", "Technical Issue. Please contact the technical team.", "warning");
      }
    } catch (error) {
      console.error("Error saving message:", error);
      swal("Error", "Something went wrong. Check console.", "error");
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 14, p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: "#2e7d32" }}>
        Send WhatsApp Message
      </Typography>

      <TextField
        placeholder="Type your message here... Use {name}, {email}, {link}"
        multiline
        minRows={8}
        maxRows={10}
        fullWidth
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        variant="outlined"
        sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#ffffff" } }}
      />

      <Button
        variant="contained"
        color="success"
        endIcon={<SendIcon />}
        onClick={handleSaveCustomMessage}
        sx={{ textTransform: "none", fontWeight: 600 }}
        fullWidth
      >
        Save Message
      </Button>
    </Box>
  );
};

export default WhatsAppCustomMessage;
